var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Alert as MuiAlert, styled, alpha, alertClasses } from '@mui/material';
import IconButton from '../IconButton';
import { CheckIcon, ErrorIcon, WarningIcon, InfoIcon, CloseIcon } from '../icons';
var AlertRoot = styled(MuiAlert)(function (_a) {
    var _b;
    var theme = _a.theme, type = _a.type;
    return _b = {
            color: theme.palette.text.secondary,
            padding: '4px 16px',
            border: '1px solid',
            borderColor: theme.palette[type].main,
            backgroundColor: alpha(theme.palette[type].main, 0.25)
        },
        _b["& ." + alertClasses.action] = {
            padding: 0,
        },
        _b;
});
var Icon = function (_a) {
    var icon = _a.icon, type = _a.type;
    if (icon === null)
        return null;
    if (icon === undefined) {
        var typeIcons = {
            success: React.createElement(CheckIcon, null),
            error: React.createElement(ErrorIcon, null),
            warning: React.createElement(WarningIcon, null),
            info: React.createElement(InfoIcon, null),
        };
        if (typeIcons[type]) {
            return typeIcons[type];
        }
    }
    return React.createElement(React.Fragment, null,
        " ",
        icon,
        " ");
};
var Alert = function (_a) {
    var type = _a.type, children = _a.children, message = _a.message, icon = _a.icon, onClose = _a.onClose, colorProp = _a.color, otherProps = __rest(_a, ["type", "children", "message", "icon", "onClose", "color"]);
    var _b = React.useState(true), show = _b[0], setShow = _b[1];
    var handleClose = function (e) {
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
        setShow(false);
    };
    if (show === false)
        return null;
    return (React.createElement(AlertRoot, __assign({ type: type, show: show, color: colorProp || type, icon: React.createElement(Icon, { icon: icon, type: type }), action: onClose && (React.createElement(IconButton, { onClick: handleClose },
            React.createElement(CloseIcon, null))) }, otherProps), message || children));
};
Alert.defaultProps = {
    type: 'info',
};
export default Alert;
